import React from "react";
import { useLocation } from "react-router-dom";
import "./CSS/ComingSoon.css";

const ComingSoon = () => {
  const { state } = useLocation();
  const title = state?.title || "This module";
  const description = state?.description || "This part of the boutique workflow hasn't been built yet.";

  return (
    <div className="coming-soon-page">
      <div className="coming-soon-card">
        <div className="coming-soon-icon">🧵</div>
        <h2>{title}</h2>
        <p>{description}</p>
        <span className="coming-soon-badge">Coming soon</span>
      </div>
    </div>
  );
};

export default ComingSoon;
